import { render } from "./PrintAllApprovedDialog.vue?vue&type=template&id=67fc5f84"
import script from "./PrintAllApprovedDialog.vue?vue&type=script&lang=js"
export * from "./PrintAllApprovedDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__